import React from 'react';

import CaregiverListScene from './CaregiverListScene';
import {generateFilterOptions} from './scene/filter/FilterGenerator';

import backend from 'utils/backend';

const filterOptions = generateFilterOptions();
const formatLanguageFilter = (labels) => labels.join(' ');

const CaregiverList = (props) => {
  return (
    <CaregiverListScene
      {...props}
      caregiverApi={backend.caregiver}
      caregiverDetailBasePath='/caregiver'
      filterOptions={filterOptions}
      formatLanguageFilter={formatLanguageFilter}
      showMapFilter={true}
      statusTranslationKey='caregiver.Status'
      titleExpression='caregiver.CaregiverList.Title'
    />
  );
};

export default React.memo(CaregiverList);
